export const environment = {
  linkPrefix: 'https://storage.googleapis.com/skillztank-staging.appspot.com/',
  gsLinkPrefix: 'gs://skillztank-staging.appspot.com/',
  apiUrl: 'https://dev.api.skillztank.com/',
  socketUrl: 'http://localhost:3001/',
  mediaServerUrl: 'https://dev.live.skillztank.com/',
  production: false,
  showLoginPoster: false,
  showSignupPoster: false,
  resetPasswordLink: 'https://skillztank-k8s.com/redirect/appName',
  googleCredentials: {
    apiKey: 'AIzaSyCWZFmplT_9Y76zTnKYRFUTEED5KvqovR8',
    authDomain: 'skillztank-staging.firebaseapp.com',
    databaseURL: 'https://skillztank-staging.firebaseio.com/',
    projectId: 'skillztank-staging',
    storageBucket: 'skillztank-staging.appspot.com',
    messagingSenderId: '1060584541217',
    appId: '1:1060584541217:web:b86e6348ad4760c1cf6760',
    measurementId: 'G-5JK5K0XFY1',
  },
  profilePictureBucketName: 'skillztank-staging-profile-pictures',
  publicBucketStorage: 'skillztank-public-courses-staging',
  env: 'stg',
  publicVapidKey: 'BHCCKIP-JXE_BhPMx6aHatK8Rd20M2H6-nRldSjOA0L38wviO5hf_V6rjQ0eaNvm-ndcL1SbB6OTcR7UWXbM9uk',
  createPortalFn: 'ext-firestore-stripe-payments-jm9v-createPortalLink',

  // firebaseFunctionsURL: "https://us-central1-skillztank-staging.cloudfunctions.net/"

  // Feature flags
  enableAppCustomization: false,
  enableLiveTranscription: false,
  domain: 'skillztank-k8s.com',
  mainDomain: 'dev.skillztank.com',
};
